import { ChestShape, HipShape, BellyShape } from '../types/widget.state';

export function setChestShape(
  maleChestShape: ChestShape,
  femaleChestShape: ChestShape
) {
  return {
    U_CHESTSHAPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'U_CHESTSHAPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          image: maleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          image: maleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          image: maleChestShape.broad.imageUrl,
        },
      ],
    },
    CHEST_TYPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'CHEST_TYPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          image: maleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          image: maleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          image: maleChestShape.broad.imageUrl,
        },
      ],
    },
    U_CHESTSHAPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'U_CHESTSHAPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          image: femaleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          image: femaleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          image: femaleChestShape.broad.imageUrl,
        },
      ],
    },
    CHEST_TYPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'CHEST_TYPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          image: femaleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          image: femaleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          image: femaleChestShape.broad.imageUrl,
        },
      ],
    },
    // Support for unisex
    U_CHESTSHAPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'U_CHESTSHAPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          male_image: maleChestShape.slim.imageUrl,
          female_image: femaleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          male_image: maleChestShape.average.imageUrl,
          female_image: femaleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          male_image: maleChestShape.broad.imageUrl,
          female_image: femaleChestShape.broad.imageUrl,
        },
      ],
    },
    CHEST_TYPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'CHEST_TYPE',
      options: [
        {
          key: 'CHEST_1-SLIM',
          male_image: maleChestShape.slim.imageUrl,
          female_image: femaleChestShape.slim.imageUrl,
        },
        {
          key: 'CHEST_2-AVERAGE',
          male_image: maleChestShape.average.imageUrl,
          female_image: femaleChestShape.average.imageUrl,
        },
        {
          key: 'CHEST_3-BROAD',
          male_image: maleChestShape.broad.imageUrl,
          female_image: femaleChestShape.broad.imageUrl,
        },
      ],
    },
  };
}

export function setHipShape(maleHipShape: HipShape, femaleHipShape: HipShape) {
  return {
    U_HIPSHAPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'U_HIPSHAPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          image: maleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          image: maleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          image: maleHipShape.wide.imageUrl,
        },
      ],
    },
    HIPS_TYPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'HIPS_TYPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          image: maleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          image: maleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          image: maleHipShape.wide.imageUrl,
        },
      ],
    },
    U_HIPSHAPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'U_HIPSHAPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          image: femaleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          image: femaleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          image: femaleHipShape.wide.imageUrl,
        },
      ],
    },
    HIPS_TYPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'HIPS_TYPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          image: femaleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          image: femaleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          image: femaleHipShape.wide.imageUrl,
        },
      ],
    },
    // Support for unisex
    U_HIPSHAPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'U_HIPSHAPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          male_image: maleHipShape.slim.imageUrl,
          female_image: femaleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          male_image: maleHipShape.average.imageUrl,
          female_image: femaleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          male_image: maleHipShape.wide.imageUrl,
          female_image: femaleHipShape.wide.imageUrl,
        },
      ],
    },
    HIP_TYPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'HIP_TYPE',
      options: [
        {
          key: 'HIP_1-SLIM',
          male_image: maleHipShape.slim.imageUrl,
          female_image: femaleHipShape.slim.imageUrl,
        },
        {
          key: 'HIP_2-AVERAGE',
          male_image: maleHipShape.average.imageUrl,
          female_image: femaleHipShape.average.imageUrl,
        },
        {
          key: 'HIP_3-WIDE',
          male_image: maleHipShape.wide.imageUrl,
          female_image: femaleHipShape.wide.imageUrl,
        },
      ],
    },
  };
}

export function setBellyShape(
  maleBellyShape: BellyShape,
  femaleBellyShape: BellyShape
) {
  return {
    U_BELLYSHAPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'U_BELLYSHAPE',
      options: [
        {
          key: 'BELLY_NS_1-FLAT',
          image: maleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_NS_2-AVERAGE',
          image: maleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_NS_3-ROUND',
          image: maleBellyShape.round.imageUrl,
        },
      ],
    },
    BELLY_TYPE__MALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'm',
          },
        },
      ],
      key: 'BELLY_TYPE',
      options: [
        {
          key: 'BELLY_NS_1-FLAT',
          image: maleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_NS_2-AVERAGE',
          image: maleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_NS_3-ROUND',
          image: maleBellyShape.round.imageUrl,
        },
      ],
    },
    U_BELLYSHAPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'U_BELLYSHAPE',
      options: [
        {
          key: 'BELLY_NS_1-FLAT',
          image: femaleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_NS_2-AVERAGE',
          image: femaleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_NS_3-ROUND',
          image: femaleBellyShape.round.imageUrl,
        },
      ],
    },
    BELLY_TYPE__FEMALE: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'f',
          },
        },
      ],
      key: 'BELLY_TYPE',
      options: [
        {
          key: 'BELLY_NS_1-FLAT',
          image: femaleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_NS_2-AVERAGE',
          image: femaleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_NS_3-ROUND',
          image: femaleBellyShape.round.imageUrl,
        },
      ],
    }, // Support for unisex
    U_BELLYSHAPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'U_BELLYSHAPE',
      options: [
        {
          key: 'BELLY_1-FLAT',
          male_image: maleBellyShape.flat.imageUrl,
          female_image: femaleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_2-AVERAGE',
          male_image: maleBellyShape.average.imageUrl,
          female_image: femaleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_3-ROUND',
          male_image: maleBellyShape.round.imageUrl,
          female_image: femaleBellyShape.round.imageUrl,
        },
      ],
    },
    BELLY_TYPE__UNISEX: {
      conditions_update: [
        {
          product_filters: {
            product_gender: 'u',
          },
        },
      ],
      key: 'BELLY_TYPE',
      options: [
        {
          key: 'BELLY_1-FLAT',
          male_image: maleBellyShape.flat.imageUrl,
          female_image: femaleBellyShape.flat.imageUrl,
        },
        {
          key: 'BELLY_2-AVERAGE',
          male_image: maleBellyShape.average.imageUrl,
          female_image: femaleBellyShape.average.imageUrl,
        },
        {
          key: 'BELLY_3-ROUND',
          male_image: maleBellyShape.round.imageUrl,
          female_image: femaleBellyShape.round.imageUrl,
        },
      ],
    },
  };
}
